import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useClaims } from "@/lib/use-claims";
import { hasPermission, type Permission } from "@/lib/permissions";

/**
 * Route guard: renders children only if the signed-in admin's role grants the
 * permission; otherwise redirects to the in-app Unauthorized screen. The server
 * still enforces authorization on every request — this only prevents a confusing
 * dead-end for pages the user can't use.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const { role } = useClaims();
  if (!hasPermission(role, permission)) return <Navigate to="/unauthorized" replace />;
  return <>{children}</>;
}
